import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';

const NotFound = () => (
  <main className="container-lux py-32 text-center">
    <p className="tracking-luxe text-[#b78d3c] mb-3">404</p>
    <p className="font-display text-4xl md:text-5xl mb-4">This page doesn't exist.</p>
    <p className="text-[#1a120b]/60 mb-8 max-w-md mx-auto">
      The page you're looking for may have moved or never existed. Let's get
      you back to something sweeter.
    </p>
    <Link to="/shop" className="btn-primary inline-flex items-center gap-2">
      <ShoppingBag className="w-4 h-4" /> Continue shopping
    </Link>
  </main>
);

export default NotFound;
